<template>
  <div v-if="tariff" class="tariff-wrapper">
    <div class="tariff-card">
      <div class="data-box tariff-card-header" :style="{ backgroundColor: getTariffColor }">
        <span class="text-white text-xl text-semibold">{{ tariff.name }}</span>
        <span class="text-white value-lg">{{ getDetailByType('VOLUME', 'primary') }}</span>
        <span class="text-white text-xl text-semibold">{{ getDetailByType('VOLUME', 'secondary') }}</span>
      </div>
      <div class="data-box tariff-card-body">
        <div class="data-box-content">
          <span class="value-lg">{{ getDetailByType('FLAT', 'primary') }}</span>
          <span class="text-xl">{{ getDetailByType('FLAT', 'secondary') }}</span>
        </div>
        <div class="price-box">
          <span class="value-lg value-price">{{ getDetailByType('PRICE', 'primary') }}</span>
        </div>
      </div>
    </div>
    <button class="button button--secondary" @click="showModal = true">
      Tarifdetails anzeigen
    </button>
    <CustomModal
      @next="showModal = false"
      @close="showModal = false"
      :show-next="true"
      :show-prev="false"
      :next-text="'Schließen'"
      :visible="showModal"
    >
      <template slot="header"> {{ tariff.name }} - Tarifdetails </template>
      <div class="modal-body-wrapper">
        <div class="tariff-details">
          <ShowMore :initialText="tariff.tariffText"></ShowMore>

        </div>
      </div>
    </CustomModal>
  </div>
</template>

<script>
// import CustomModalWrapper from '@/components/generic/CustomModalWrapper.vue'
import CustomModal from '@/components/generic/CustomModal.vue'
import ShowMore from '@/components-v2/generic/ShowMore.vue'

export default {
  name: 'TariffCard',
  components: {
    // CustomModalWrapper
    CustomModal,
    ShowMore
  },
  props: {
    tariff: {
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    getTariffColor() {
      return this.tariff ? `var(--tariff-${this.tariff.tariffId}` : 'var(--tariff-default)'
    }
  },
  methods: {
    getDetailByType(type, key) {
      const item = this.tariff?.extraDataDetails.find(detail => detail.type === type)
      return item ? item[key] : ''
    }
  }
}
</script>
